import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "product_lst" }
const _hoisted_2 = { class: "thum_bx" }
const _hoisted_3 = { class: "product_info_bx" }
const _hoisted_4 = { class: "txt" }
const _hoisted_5 = { class: "price_area" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "blind" }, "정상가", -1)
const _hoisted_7 = { class: "num normal_price" }
const _hoisted_8 = { class: "num rate_sale" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "blind" }, "판매가", -1)
const _hoisted_10 = { class: "num sale_price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("ul", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
      return (_openBlock(), _createBlock("li", {
        class: "product_item",
        key: product.productId,
        product: product
      }, [
        _createVNode("a", {
          href: "#",
          class: "product_link",
          onClick: _withModifiers(($event: any) => (_ctx.moveToProductDetail(product.productId)), ["prevent"])
        }, [
          _createVNode("div", _hoisted_2, [
            _createVNode("img", {
              src: product.productImageUrl,
              class: "thum_img",
              alt: "",
              onLoad: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('loadProductImage')))
            }, null, 40, ["src"])
          ]),
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, _toDisplayString(product.productName), 1),
            _createVNode("div", _hoisted_5, [
              (product.isDiscounted)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_6,
                    _createVNode("del", _hoisted_7, _toDisplayString(product.commaListPrice) + "원", 1),
                    _createVNode("span", _hoisted_8, _toDisplayString(product.discountRate) + "%", 1)
                  ], 64))
                : _createCommentVNode("", true),
              _hoisted_9,
              _createVNode("em", _hoisted_10, _toDisplayString(product.commaSalePrice) + "원", 1)
            ])
          ])
        ], 8, ["onClick"])
      ], 8, ["product"]))
    }), 128))
  ]))
}